/* eslint-disable max-lines-per-function */
import React from 'react';
import { connect } from 'react-redux';
import { push as Push } from 'redux-first-history';
import { withTranslation } from 'react-i18next';
import { compose } from 'react-recompose';
import { DomainPayload, DomainDetail } from '@dev/ee-api/ee-api-models';
import { Domains as SettingsModule } from '@dev/ee-modules';
import { ApplicationState as State } from '@api/store';
import { ShowDialog, UpdateDialog } from '@api/store/dialog/actions';
import { ShowDialogParams } from '@api/store/dialog/types';
import {
    LoadDomains,
    AddDomainStart,
    DeleteSpecificDomain,
    DomainSetDefaultSender,
    UpdateDomainStart,
    VerifySpecificDomain,
} from '@api/store/domain/actions';
import { LoadValidEmails, AddValidEmail, ResendEmailVerification, DeleteValidEmail } from '@api/store/validemails/actions';
import { SettingsPaths } from '@api/services/dictionaries/paths';
import { DomainsProps as Props } from './DomainsInterface';

const mapState = (state: State, ownProps: Props): Props => ({
    ...ownProps,
    account: state.account,
    browser: state.browser,
    dialog: state.dialog,
    domain: state.domain,
    validEmails: state.validEmails,
});
const dispatchProps = {
    ShowDialog,
    UpdateDialog,
    LoadDomains,
    AddDomainStart,
    LoadValidEmails,
    AddValidEmail,
    ResendEmailVerification,
    DeleteValidEmail,
    Push,
    DeleteSpecificDomain,
    DomainSetDefaultSender,
    UpdateDomainStart,
    VerifySpecificDomain,
};
interface DispatchProps {
    ShowDialog(params: ShowDialogParams): void;
    UpdateDialog(params: ShowDialogParams): void;
    LoadDomains(): void;
    AddDomainStart(newDomain: DomainPayload): any;
    LoadValidEmails(): void;
    AddValidEmail(email: string): any;
    ResendEmailVerification(email: string): void;
    DeleteValidEmail(email: string[]): void;
    DeleteSpecificDomain(domainName: string): void;
    Push(url: string): void;
    DomainSetDefaultSender(email: string): any;
    UpdateDomainStart(domainName: string, updateOptions: DomainDetail): any;
    VerifySpecificDomain(domainName: string): any;
}

type ExtendedProps = Props & DispatchProps;

const Domains = (props: ExtendedProps): JSX.Element => (
    <SettingsModule
        {...props}
        paths={SettingsPaths}
        domains={{
            loading: props.domain.loadingDomains,
            list: props.domain.domains,
        }}
        emails={{
            loading: props.validEmails.loadingEmails,
            list: props.validEmails.emails,
            errorMsg: props.validEmails.errorMsg,
        }}
    />
);

export default compose(withTranslation('settings'), connect<Props, DispatchProps>(mapState, dispatchProps))(Domains);
